import { render, staticRenderFns } from "./_RiskAversion.vue?vue&type=template&id=3ed5940e&scoped=true"
import script from "./_RiskAversion.vue?vue&type=script&lang=js"
export * from "./_RiskAversion.vue?vue&type=script&lang=js"
import style0 from "./_RiskAversion.vue?vue&type=style&index=0&id=3ed5940e&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3ed5940e",
  null
  
)

export default component.exports